import Vue from 'vue';
import Vuex from 'vuex';
import auth from './authentication';
import { Http } from '@/services';
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    apiLoading: false,
  },
  mutations: {
    updateApiLoading(state, value) {
      state.apiLoading = value;
    },
  },
  actions: {},
  modules: { auth },
});

Http.interceptors.request.use(
  config => {
    store.commit('updateApiLoading', true);

    return config;
  },
  error => {
    store.commit('updateApiLoading', false);
    return Promise.reject(error);
  },
);

Http.interceptors.response.use(
  response => {
    store.commit('updateApiLoading', false);
    return response;
  },
  error => {
    store.commit('updateApiLoading', false);
    return Promise.reject(error);
  },
);
export default store;
